import React from "react";
import { Text, Flex, type FlexProps } from "@chakra-ui/react";

export function FilterOption({
  hasIcon,
  label,
  children,
  ...props
}: { hasIcon?: boolean; label?: string; filter?: string } & FlexProps) {
  return (
    <Flex
      align="center"
      bg="product.gray.50"
      border="1px"
      borderColor="brand.border.extraLight"
      boxShadow="0px 0.969px 1.938px 0px rgba(16, 24, 40, 0.05)"
      color="brand.text.light"
      borderRadius="4px"
      gap={{ base: "tiniest", lg: "tinier" }}
      fontWeight="semibold"
      flexWrap="nowrap"
      whiteSpace="nowrap"
      p={{ base: "tiniest", lg: "tinier" }}
      {...props}
    >
      {label && (
        <Text as="span" color="brand.textSecondary.light">
          {label}
        </Text>
      )}
      {children}
    </Flex>
  );
}
